import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useAppContext } from '../../../../hooks/useAppContext';
import type { Reaction } from '../../extensions/comment/Comment';

interface Props {
  id: string;
  isDisabled?: boolean;
  reactions: Reaction[];
  onAddReaction: (id: string) => void;
  onRemoveReaction: (id: string) => void;
}

export const CommentReactionButton = (props: Props) => {
  const { id, reactions, isDisabled, onAddReaction, onRemoveReaction } = props;

  const { user } = useAppContext();

  const onClick = React.useCallback(() => {
    const reaction = reactions.find((reaction) => reaction.userId === user.id);

    if (reaction) {
      onRemoveReaction(id);
    } else {
      onAddReaction(id);
    }
  }, [id, reactions, user.id, onAddReaction, onRemoveReaction]);

  return (
    <ChakraV3.Tooltip
      content={
        <ChakraV3.HStack>
          {reactions.map((reaction) => reaction.username).join(', ')} reacted with
          <em-emoji id={id} />
        </ChakraV3.HStack>
      }
    >
      <ChakraV3.Button
        size='sm'
        p='2'
        rounded='full'
        variant='ghost'
        onClick={onClick}
        disabled={isDisabled}
      >
        <ChakraV3.HStack gap={1}>
          <em-emoji id={id} />
          <ChakraV3.Text fontSize='2xs'>{reactions.length}</ChakraV3.Text>
        </ChakraV3.HStack>
      </ChakraV3.Button>
    </ChakraV3.Tooltip>
  );
};
